export const safariRegEx = /^((?!chrome|android).)*safari/i;

export function isBrowserSafari() {
  const isSafari = safariRegEx.test(navigator.userAgent);
  return isSafari;
}
